import { Injectable } from '@angular/core';
import { PageEvent as NgPageEvent } from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { BatchDataSource } from './batch-data-source';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class BatchApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public getDataSource(role: string): BatchDataSource {
    return new BatchDataSource(this, role);
  }

  public listWithPageEvent(role: string, filter?: {}, PageEvent?: NgPageEvent) {
    let endpoint = `${role}/batches`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithPageEventFilter(endpoint, PageEvent, filter, url)
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) => this.Api.handleError(error));
  }

  public getBatchOrders(role: string, batchId) {
    let endpoint = `${role}/batches/${batchId}/orders`;

    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url)
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) => this.Api.handleError(error));
  }

  public getBatchExport(role: string, filter) {
    let endpoint = `${role}/batches/export`;

    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithoutPageEventFilter(endpoint, filter, url)
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) => this.Api.handleError(error));
  }

  // protected endpoint(role: string, Batch?: IBatch, action?: string) {
  //   const id = Batch ? Batch.id : null;

  //   let endpoint = environment.endpoint[role].batches(id);

  //   !!action && (endpoint += '/' + action);

  //   return endpoint;
  // }

  protected addFilterToEndpoint(endpoint: string, filter?: {}) {
    !!filter &&
      Object.keys(filter).map((key) => {
        endpoint += `/${key}:${encodeURI(filter[key])}`;
      });
    endpoint +=
      !endpoint.includes('page-index') && `/page-size/24/page-index/0`;
    return endpoint;
  }
}
